import * as React from "react";
import * as ReactDOM from "react-dom";
import { useEffect, useRef, useState } from "react";
import { ProductList } from "./ProductList";
import { LanguagesType } from "../../models/languagesType";
import { useTranslation } from "../hooks/useTranslation";
import { WAProduct } from "../../utils/productType";
import { displayLinks, DisplayLinksType } from "../../utils/displayLinks";
import styles from "./Header.module.scss";

export type MenuProps = {
  lang: LanguagesType;
  productName: WAProduct;
};

export const ProductMenu: React.FC<MenuProps> = ({
  lang,
  productName,
}) => {
  const [isProductOpen, setIsProductOpen] = useState<boolean>(false);
  const displayedLinks: DisplayLinksType = displayLinks[lang as LanguagesType];
  const { t, setLanguage } = useTranslation();

  const handleProductOpen = () => {
    setIsProductOpen((prev) => !prev);
  };

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  return (
    <>
      <div className={styles.products}>
        <div
          className={`${styles.productsBtn} ${isProductOpen && styles.adjust}`}
          onClick={handleProductOpen}
        >
          <span
            className={`${styles.hamburger} ${isProductOpen && styles.cross}`}
          ></span>
          <ProductList
            t={t}
            displayedLinks={displayedLinks}
            isProductOpen={isProductOpen}
            handleProductOpen={handleProductOpen}
            productName={productName}
          />
        </div>
      </div>
    </>
  );
};
